import { createRouter, createWebHistory } from 'vue-router';

import publicRoutes   from './routes/public.js';
import teacherRoutes  from './routes/teacher.js';
import studentRoutes  from './routes/student.js';
import adminRoutes    from './routes/admin.js';
import { authGuard }  from './guards/authGuard.js';

const routes = [
	publicRoutes,
	teacherRoutes,
	studentRoutes,
	adminRoutes,
	// dynamic routes that need auth but no role-restriction
	{
		path : '/lesson/:lessonId/feedback',
		name : 'LessonFeedback',
		props: true,
		meta : { requiresAuth: true },
		component: () => import('@/components/LessonFeedback.vue'),
	},
	{
		path : '/class/:id',
		name : 'ClassDetail',
		meta : { requiresAuth: true },
		component: () => import('@/views/ClassDetail.vue'),
	},
	{
		path : '/create-course',
		name : 'CreateCourse',
		meta : { requiresAuth: true },
		component: () => import('@/views/CreateCourse.vue'),
	},
	{
		path : '/callback',
		name : 'AuthCallback',
		meta : { requiresAuth: true },
		component: () => import('@/views/CallBack.vue'),
	},
	{
		path : '/settings',
		name : 'Settings',
		meta : { requiresAuth: true },
		component: () => import('@/views/SettingsView.vue'),
	},
	// 404 fallback
	{
		path: '/:pathMatch(.*)*',
		name: 'NotFound',
		component: () => import('@/views/NotFound.vue'),
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, from) => authGuard(to, from));

export default router;
